import React, { useMemo } from 'react'
import { observer } from 'mobx-react-lite';
import EChartsReact from 'echarts-for-react';
import Switch from '../../../../../FormComponents/Switch'

export default observer(function Gender({ malePercentage, femalePercentage, values, setFieldValue, advSideScenario }) {
  
  const option = useMemo(() => ({
    yAxis: {
      type: 'category',
      data: ['Female', 'Male'],
      axisLine: { show: false },
      axisTick: { show: false }
    },
    xAxis: {
      show: false,
      max: 100
    },
    series: [{
      type: 'bar',
      data: [
        {
          value: (femalePercentage * 100).toFixed(2),
          itemStyle: { color: '#2CCDB4' }
        },
        {
          value: (malePercentage * 100).toFixed(2),
          itemStyle: { color: '#C1F6EE' }
        }
      ],
      label: {
        show: true,
        position: 'right',
        formatter: '{c}%',
        fontSize: 14,
        fontWeight: 'bold'
      },
      barWidth: '40%'
    }],
    grid: {
      left: 60,
      right: 50,
      top: 0,
      bottom: 0
    }
  }), [malePercentage, femalePercentage])

  return (
    <div className="w-full bg-white dark:bg-rb-dark-mode p-4 rounded-lg">
      <div className="flex gap-4 items-center mb-4">
        <p className={`font-bold text-xl dark:text-white ${advSideScenario || values.audience_gender_visible ? '' : 'opacity-30'}`}>Gender</p>
        {!advSideScenario && <Switch name="audience_gender_visible" value={values.audience_gender_visible} onChange={({ target: { checked }}) => setFieldValue('audience_gender_visible', checked, true)} eyeSwitch />}
      </div>
      <div className={`${advSideScenario || values.audience_gender_visible ? '' : 'opacity-30'}`}>
        <EChartsReact option={option} style={{ width: '100%', height: '180px' }} />
      </div>
    </div>
  )
})
